export function validFollowUp(row) {
  const value=row?.follow_up;
  if(value===undefined)return true;
  return row.kind==="collaboration"&&/^\/collaboration\?request=[^&#?]+$/.test(row.path)&&
    ["awaiting","expired","time_passed","declined"].includes(value?.reason)&&
    (value.reason==="awaiting"?row.state==="waiting":row.state==="needs_decision")&&
    Number.isInteger(value.answered)&&value.answered>=0&&Number.isInteger(value.total)&&value.total>0&&
    value.answered<=value.total&&(value.reason!=="awaiting"||value.answered<value.total)&&
    typeof value.expires_at==="string"&&Number.isFinite(Date.parse(value.expires_at))&&
    typeof value.next_step==="string"&&value.next_step.trim().length>0&&value.next_step.length<=500;
}
